import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    EmployeeReportsIndexTable,
    ReportDownloadService,
    TimeTrackingMenuService,
} from '@app/modules/time-tracking/services';
import { AuthService, NotifyService } from '@app/services';
import * as FileSaver from 'file-saver';
import moment from 'moment';

@Component({
    templateUrl: './reports-index.template.html',
})
export class ReportsIndexView {
    isLoading = false;
    table: EmployeeReportsIndexTable;
    range = new FormGroup({
        start: new FormControl(new Date(new Date().getFullYear(), 0, 1)), // start of the year
        end: new FormControl(new Date(new Date().getFullYear(), 11, 31)), // end of the year
    });

    filterFrom = 'workedOn.from';
    filterTo = 'workedOn.to';

    constructor(
        public menuService: TimeTrackingMenuService,
        private auth: AuthService,
        private reportDownloadService: ReportDownloadService,
        private notify: NotifyService
    ) {
        this.table = new EmployeeReportsIndexTable(this.auth);

        // Make the initial call with the date range by default
        this.table.paginator.filters = {
            workedOn: {
                from: moment(this.range.get('start')?.value).format('YYYY-MM-DD'),
                to: moment(this.range.get('end')?.value).format('YYYY-MM-DD'),
            },
            ...this.table.paginator.filters,
        };

        // Set them as the default active filters always
        this.table.activeFilters.set(this.filterFrom, moment(this.range.get('start')?.value).format('YYYY-MM-DD'));
        this.table.activeFilters.set(this.filterTo, moment(this.range.get('end')?.value).format('YYYY-MM-DD'));
    }

    async onExport(format: 'csv' | 'xlsx', urlExtension: string): Promise<void> {
        try {
            const data = await this.reportDownloadService.downloadFile(
                urlExtension,
                this.table.paginator.currentQuery.searchPayload()
            );
            FileSaver.saveAs(data, `TimeTrackingEmployeeReport.${format}`);
        } catch (err) {
            this.notify.error(err);
        }
    }

    onDateSelectionComplete(): void {
        const startDate = moment(this.range.get('start')?.value);
        const endDate = moment(this.range.get('end')?.value);

        // Set the filters to be active (This means you can add more filters on top through the table and compound)
        this.table.activeFilters.set(this.filterFrom, startDate.format('YYYY-MM-DD'));
        this.table.activeFilters.set(this.filterTo, endDate.format('YYYY-MM-DD'));

        // Set the filters and make the table call the backend
        this.table.paginator.filters = {
            ...this.table.paginator.filters,
            workedOn: {
                from: startDate.format('YYYY-MM-DD'),
                to: endDate.format('YYYY-MM-DD'),
            },
        };
    }
}
